import React, { useRef } from "react";

import DoughnutDataset from "../types/DoughnutDataset";
import useDoughnut from "../hooks/useDoughnut";

import Card from "../../../common/Card/Card";
import Typography from "../../../common/Typography/Typography";

import styles from "./Doughnut.module.css";

interface Props {
    title?: string;
    datasets: DoughnutDataset[];
    className?: string;
}

const Doughnut = ({ title, datasets, className = "" }: Props) => {
    const ref = useRef(null);
    useDoughnut(ref, datasets);

    return (
        <Card padding="large" className={`${className} ${styles.card}`}>
            {title ? (
                <Typography as="h3" variant="smallCaps">
                    {title}
                </Typography>
            ) : null}
            <div className={styles.mainContent}>
                <ul className={styles.figures}>
                    {datasets.map(({ label, data, color }) => (
                        <li key={label}>
                            <dl className={styles.dataset}>
                                <Typography as="dt" variant="smallCaps" color="pine">
                                    {label}
                                </Typography>
                                <Typography as="dd" variant="figure" fontSize="800">
                                    <span className="flex items-center gap-0.5">
                                        {data}
                                        <span className="w-1 h-1 rounded-full" style={{ backgroundColor: color }} />
                                    </span>
                                </Typography>
                            </dl>
                        </li>
                    ))}
                </ul>
                <div className={styles.doughnut}>
                    <canvas className="w-[105px]" ref={ref} />
                </div>
            </div>
        </Card>
    );
};

export default Doughnut;
